
import { Button } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTutorial } from "@/contexts/TutorialContext";
import { useIsMobile } from "@/hooks/use-is-mobile";

export default function TutorialButton() {
  const { startTutorial } = useTutorial();
  const isMobile = useIsMobile();
  
  // Don't show the tutorial button on mobile
  if (isMobile) return null;
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={startTutorial}
            className="absolute left-2 top-2 z-10"
            aria-label="Tutorial starten"
          >
            <HelpCircle className="h-5 w-5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Tutorial starten</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
